(function ($) {

	class CheckoutContact {

		$contact_form = null

		constructor() {
			$(document).gp_ready(this.init_form)
		}

		init_form = () => {

			// Init elements
			this.$contact_form = $('form[data-form-id="checkout-contact"]')

			// Init toggle events
			this.init_toggle_content('add_company_info', '.billing-company')
			this.init_toggle_content('add_shipping_info', '.shipping-address')
			this.init_toggle_content('sign_up', '.checkout-contact-account__password')

		}

		init_toggle_content(checkbox_name, content_selector) {

			let $checkbox = this.$contact_form.find('input[name="' + checkbox_name + '"]')
			let $content = this.$contact_form.find(content_selector)

			// Show/hide on init
			if ($checkbox.is(':checked')) {
				$content.show()
			} else {
				$content.hide()
			}

			// Bind toggle
			$checkbox.off('change.toggle-' + checkbox_name)
			$checkbox.on('change.toggle-' + checkbox_name, () => {
				if ($checkbox.is(':checked')) {
					$content.slideDown(250)
				} else {
					$content.slideUp(250)
				}
			})
		}

	}

	new CheckoutContact();

})(jQuery)